import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import quicklink from "quicklink/dist/quicklink.mjs";

import api from 'api';
import WP from 'WP';
import { PageMarkup } from 'views/Page';

import { 
    setCurrentView,
    setHeaderTopPadding
} from 'store'

class Home extends Component {

    componentDidMount() {
        this.props.setCurrentView(null);

        api.pageFetcher.getByIds({ ids: [WP.front_page] })
            .then(resp => {
                this.props.setCurrentView(resp.data[0]);
                quicklink();
            });
        this.props.setHeaderTopPadding(true);
    }

    componentWillUnmount() {
        this.props.setHeaderTopPadding(false);
    }

    render() {
        const { home } = this.props;

        return <PageMarkup page={home} />
    }
}

const mapStateToProps = state => {
    return {
        home: state.currentView,
        availability: state.availabilityFields
    }
}

const actions = {
    setCurrentView,
    setHeaderTopPadding,
}

export default connect(mapStateToProps, actions)(withRouter(Home));